import { cn } from '@repo/lib/cn';
import { questionMultipleChoiceSchema } from '@repo/schemas/quiz/questionMultipleChoice';
import { CircleAlertIcon, PlusIcon } from 'lucide-react';

import { QuestionContentFormField, QuestionMultipleAnswerField } from '@/components/features/quiz/question/question-builder';
import { Button } from '@/components/ui/button';
import { ErrorMessage, Form } from '@/components/ui/form';
import { useQuestionMultipleForm } from '@/hooks/questions';
import { questionsLabel } from '@/lib/questions-labels';
import { formErrorToast } from '@/utils/form';

import type { QuestionMultipleFormProps } from '.';

export function QuestionMultipleForm(questionMultipleFormProps: QuestionMultipleFormProps) {
  const { data, onSubmit = () => {}, ...props } = questionMultipleFormProps;
  const { form, multipleQuestionAnswers, toggleCorrect, handleAddAnswer, handleRemoveAnswer } = useQuestionMultipleForm(data);

  return (
    <Form {...form}>
      <form
        {...props}
        noValidate
        onSubmit={form.handleSubmit(onSubmit, (_error) => {
          formErrorToast(form, questionMultipleChoiceSchema);
        })}
      >
        <div className="divide-border-primary divide-y">
          <QuestionContentFormField />
          <div className="space-y-6 p-3">
            <div className="text-muted-foreground flex items-center gap-1 text-xs">
              <CircleAlertIcon className="size-4" />
              <p>{data?.type && questionsLabel[data.type].builderDesc}</p>
            </div>
            <ErrorMessage className="my-4 min-h-0 w-full" name={'answers.root'} />
            <div className="flex flex-col items-stretch gap-3 xl:flex-row">
              {multipleQuestionAnswers.fields.map((field, index) => (
                <QuestionMultipleAnswerField
                  key={field.id}
                  form={form}
                  index={index}
                  toggleCorrect={toggleCorrect}
                  removeAnswer={handleRemoveAnswer}
                  canRemove={multipleQuestionAnswers.fields.length > 2}
                />
              ))}
              <Button
                type="button"
                variant={'outline'}
                size={'sm'}
                className={cn('border-dashed w-full xl:w-auto xl:my-auto', multipleQuestionAnswers.fields.length === 5 && 'hidden')}
                onClick={handleAddAnswer}
              >
                <PlusIcon />
                <span className="block xl:hidden">Dodaj odpowiedź</span>
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
}
